import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-calendario-importar-cargar-archivo',
  standalone: false,
  templateUrl: './calendario-importar-cargar-archivo.component.html',
  styleUrls: ['../calendario.component.scss']
})
export class CalendarioImportarCargarArchivoComponent implements OnInit {

  @Input()
  archivoForm: UntypedFormGroup;

  @Input()
  loading$: Observable<boolean>;

  @Output()
  fileSelectEvent: EventEmitter<any>;

  @Input()
  escuelas$: Observable<any[]>;



  constructor(private global: GlobalService) {
    this.fileSelectEvent = new EventEmitter();
  }

  ngOnInit(): void {
  }

  fileProgress(file: any) {
    this.fileSelectEvent.emit(file);
  }

}
